import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex-container-row" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"stretch","align-items":"stretch","min-width":"30px","height":"100%"} }
const _hoisted_6 = { class: "purchase-button-content" }
const _hoisted_7 = { style: {"display":"flex","justify-content":"stretch","align-items":"stretch","min-width":"30px","height":"100%"} }
const _hoisted_8 = { class: "purchase-button-content" }
const _hoisted_9 = { class: "sn-dialog-content" }
const _hoisted_10 = { class: "sn-dialog-table" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_app_dialog = _resolveComponent("app-dialog")!

  return (_ctx.allowPurchase)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.purchaseCount == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_k_button, {
                icon: "cart",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.requiresSerialNumber ? _ctx.openDialog() : _ctx.orderItem(1)), ["prevent"])),
                disabled: _ctx.disabledView
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('Order')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.requiresSerialNumber)
                  ? (_openBlock(), _createBlock(_component_button_group, {
                      key: 0,
                      class: "purchase-button-group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_k_button, {
                          icon: "list-unordered",
                          disabled: true
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.purchaseCount), 1)
                        ]),
                        _createVNode(_component_k_button, {
                          icon: "edit",
                          title: _ctx.localize('EditSerialNumbers'),
                          onClick: _ctx.openDialog
                        }, null, 8, ["title", "onClick"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_button_group, {
                      key: 1,
                      rounded: "full",
                      disabled: _ctx.disabledView,
                      class: "purchase-button-group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_k_button, {
                          icon: "minus",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orderItem(-1)))
                        }),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.purchaseCount), 1)
                        ]),
                        _createVNode(_component_k_button, {
                          icon: "plus",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.orderItem(1)))
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"])),
                _createVNode(_component_k_button, {
                  icon: "delete",
                  onClick: _ctx.deleteWithUndo,
                  disabled: _ctx.disabledView,
                  class: "purchase-delete-button",
                  title: _ctx.localize('Remove')
                }, null, 8, ["onClick", "disabled", "title"])
              ])
            ])),
        (_ctx.showDialog)
          ? (_openBlock(), _createBlock(_component_app_dialog, {
              key: 2,
              title: _ctx.localize('SerialNumbers'),
              onClose: _ctx.closeDialog
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.localize('EnterSerialNumbers')) + ":", 1),
                  _createElementVNode("table", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogData.serialNumbers, (sn, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(index+1) + ". ", 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_k_input, {
                            modelValue: _ctx.dialogData.serialNumbers[index],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.dialogData.serialNumbers[index]) = $event),
                            id: `txt-sn-${index}`,
                            style: {"max-width":"150px"},
                            class: _normalizeClass(_ctx.dialogData.emphasizedIndex == index ? 'sn-emphasize' : null)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "class"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_k_button, {
                            icon: "delete",
                            onClick: ($event: any) => (_ctx.removeSerialNumber(index)),
                            class: "purchase-delete-button",
                            title: _ctx.localize('Remove')
                          }, null, 8, ["onClick", "title"])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", null, [
                        _createVNode(_component_k_button, {
                          icon: "plus",
                          onClick: _ctx.addSerialNumber,
                          class: "button-green sn-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('Add')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _hoisted_12
                    ])
                  ])
                ]),
                _createVNode(_component_dialog_actions_bar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_k_button, {
                      onClick: _ctx.closeDialog,
                      class: "button-cancel"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_k_button, { onClick: _ctx.submitDialog }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('ok')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title", "onClose"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}